import { MapboxDataColumnsService } from '@/modules/ta/legacy/widget/services/types/MapboxAutoZoomService';
import { MAPBOX_LAYERS_METADATA } from '@/modules/ta/legacy/widget/mapbox.constants';

export class MapboxLayerService {
  widget = null;
  column = null;
  groupedColumn = null;
  config = null;
  layerName = null;

  constructor(widget, layerName) {
    this.widget = widget;
    this.layerName = layerName;
    this.config = MAPBOX_LAYERS_METADATA[layerName];
    this.column = MapboxDataColumnsService.getFirstSelectedColumn(widget);
    this.groupedColumn = MapboxDataColumnsService.getGroupedColumn(widget);
  }

  USCountryFilter(row) {
    return row.geocode0?.toUpperCase() === 'US' || row.geocode0?.toUpperCase() === 'USA';
  }

  getData(data) {
    return data;
  }

  filterData(data) {
    const sorted = data.map((item) => item.name);
    const thresholdPercent = this.widget.metadata.draw_options?.auto_zoom_threshold ?? 90;
    const count = Math.ceil((thresholdPercent / 100) * Math.max(sorted.length, 1));
    return sorted.slice(0, count);
  }

  getConfig(key) {
    return this.config[key];
  }

  getFilters(filteredData) {
    const filterNames = this.getConfig('FIELDS');
    filteredData = filteredData.map(String);
    return ['any', ...filterNames.map((prop) => ['in', prop, ...filteredData])];
  }
}

export class MapboxLayerUtil {
  static getMapboxLayers() {
    return Object.keys(MAPBOX_LAYERS_METADATA);
  }
}
